console.log("--------------------------------")

// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    // Optional
    loadProductFirst: true,
    styleScrollToTop: "style2",
    defaultDisplay: boostPFSThemeConfig.custom.layout,
    showPlaceholderProductList: true,
  },
};

var boostPFSTemplate = {
  soldOutClass: "product-price--sold-out grid-view-item--sold-out",

  // Grid Template
  vendorGridHtml:
    '<div class="grid-view-item__vendor">{{itemVendorLabel}}</div>',
  soldOutLabelGridHtml:
    ' <span class="product-price__sold-out">' +
    boostPFSThemeConfig.label.sold_out +
    "</span>",
  productGridItemHtml:
    '<div class="test grid-view-item {{itemSoldOutClass}} product-card">' +
    '<a class="grid-view-item__link grid-view-item__image-container full-width-link" href="{{itemUrl}}">' +
    '<span class="visually-hidden">{{itemTitle}}</span>' +
    "</a>" +
    "{{imageStyle}}" +
    "{{itemImages}}" +
    '<div class="grid-view-item__information-wrapper">' +
    '<div class="grid-view-item__title_price-wrapper">' +
    '<div class="h4 grid-view-item__title">{{itemTitle}}</div>' +
    "{{itemPrice}}" +
    "</div>" +
    '<div class="grid-view-item__max-inventory-wrapper__outer {{hideVariantSumInventoryClass}}"><div class="grid-view-item__max-inventory-wrapper__inner"><div class="grid-view-item__max-inventory-ellipse"></div><span class="grid-view-item__max-inventory">{{variantSumInventory}} <span>{{quantitySymbol}}</span> <span>i lager</span></span></div></div>' +
    '<div class="grid-view-item__max-incoming-date-wrapper__outer {{hideSoonestIncomingDateInventoryClass}}"><div class="grid-view-item__incoming-date-wrapper__inner"><div class="grid-view-item__incoming-date-ellipse"></div><span class="grid-view-item__incoming-date"><span>Åter i lager</span> {{variantMinIncomingDate}}</span></div></div>' +
    "</div>" +
    "</div>",

  // List Template
  vendorSmallListHtml:
    '<div class="list-view-item__vendor-column small--hide"><div class="list-view-item__vendor">{{itemVendorLabel}}</div></div>',
  vendorMediumListHtml:
    '<div class="list-view-item__vendor medium-up--hide">{{itemVendorLabel}}</div>',
  saleLabelListHtml:
    '<div class="list-view-item__on-sale">' +
    boostPFSThemeConfig.label.sale +
    "</div>",
  soldOutLabelListHtml:
    '<div class="list-view-item__sold-out">' +
    boostPFSThemeConfig.label.sold_out +
    "</div>",
  productListItemHtml:
    '<li href="{{itemUrl}}" class="list-view-item">' +
    '<div class="product-card product-card--list">' +
    '<div class="list-view-item__link">' +
    '<div class="list-view-item__image-column">' +
    '<div class="list-view-item__image-wrapper">' +
    '<img class="list-view-item__image" src="{{itemThumbUrl}}" alt="{{itemTitle}}">' +
    "</div>" +
    "</div>" +
    '<div class="list-view-item__title-column">' +
    '<div class="list-view-item__title">{{itemTitle}}</div>' +
    "{{itemReviews}}" +
    "{{itemSaleLabel}}" +
    "{{itemMediumVendor}}" +
    "{{itemSoldOutLabel}}" +
    "</div>" +
    "{{itemSmallVendor}}" +
    '<div class="list-view-item__price-column">{{itemPrice}}</div>' +
    "</div>" +
    "</div>" +
    "</li>",

  // Pagination Template
  previousActiveHtml:
    '<li><a href="{{itemUrl}}" ><svg aria-hidden="true" focusable="false" role="presentation" width="17" height="17" viewBox="0 0 17 17" transform="scale(-1 1)"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8138 7.96917H2.125V9.03167H12.8127L9.91615 11.9282L10.6674 12.6795L14.8463 8.50073L14.8455 8.49994L14.8463 8.49912L10.6675 4.32031L9.91619 5.07161L12.8138 7.96917Z" fill="#3E4246" fill-opacity="0.9"/></svg><span class="icon__fallback-text">Previous</span></a></li>',
  previousDisabledHtml:
    '<li><div class="btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" width="17" height="17" viewBox="0 0 17 17" transform="scale(-1 1)"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8138 7.96917H2.125V9.03167H12.8127L9.91615 11.9282L10.6674 12.6795L14.8463 8.50073L14.8455 8.49994L14.8463 8.49912L10.6675 4.32031L9.91619 5.07161L12.8138 7.96917Z" fill="#3E4246" fill-opacity="0.9"/></svg><span class="icon__fallback-text">Previous</span></div></li>',
  nextActiveHtml:
    '<li><a href="{{itemUrl}}"><svg aria-hidden="true" focusable="false" role="presentation" width="17" height="17" viewBox="0 0 17 17"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8138 7.96917H2.125V9.03167H12.8127L9.91615 11.9282L10.6674 12.6795L14.8463 8.50073L14.8455 8.49994L14.8463 8.49912L10.6675 4.32031L9.91619 5.07161L12.8138 7.96917Z" fill="#3E4246" fill-opacity="0.9"/></svg><span class="icon__fallback-text">Next</span></a></li>',
  nextDisabledHtml:
    '<li><div class="btn--disabled"><svg aria-hidden="true" focusable="false" role="presentation" width="17" height="17" viewBox="0 0 17 17"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.8138 7.96917H2.125V9.03167H12.8127L9.91615 11.9282L10.6674 12.6795L14.8463 8.50073L14.8455 8.49994L14.8463 8.49912L10.6675 4.32031L9.91619 5.07161L12.8138 7.96917Z" fill="#3E4246" fill-opacity="0.9"/></svg><span class="icon__fallback-text">Next</span></div></li>',
  paginateHtml:
    '<ul class="list--inline pagination clearfix">{{previous}}<li class="pagination__text">{{pageItems}}</li>{{next}}</ul>',

  // Sorting Template
  sortingHtml:
    '<label for="boost-pfs-filter-top-sorting-select" class="label--hidden">' +
    boostPFSThemeConfig.label.sorting +
    '</label><select id="boost-pfs-filter-top-sorting-select" class="filters-toolbar__input filters-toolbar__input--sort">{{sortingItems}}</select>',
};

(function () {
  BoostPFS.inject(this);

  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/

   
    // if(data.tags.includes("_customize-product")) return;
    
    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;

    if(data.tags.includes("_customize-product")) {
      itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, "{{itemSoldOutClass}} hidden product-hidden");
    }

    // Add soldOut class
    var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : "";
    itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : "";
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    var imgId = "ProductCardImage-" + data.id;
    var wrapperId = "ProductCardImageWrapper-" + data.id;

    // Build Image style
    var imageStyle = buildImageStyle(data);
    itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

    // Add Images
    var aspect_ratio = "";
    var itemImagesHtml =
      '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
    itemImagesHtml += '<div style="padding-top:';
    if (images.length > 0) {
      aspect_ratio = images[0]["width"] / images[0]["height"];
      itemImagesHtml += (1 / aspect_ratio) * 100;
    } else {
      itemImagesHtml += 100;
    }
    itemImagesHtml += '%;">';
    itemImagesHtml +=
      '<img id="' +
      imgId +
      '" ' +
      'class="grid-view-item__image lazyload" ' +
      'src="' +
      Utils.getFeaturedImage(images, "300x300") +
      '" ' +
      'data-src="' +
      Utils.getFeaturedImage(images, "{width}x") +
      '" ' +
      'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
      'data-aspectratio="' +
      aspect_ratio +
      '" ' +
      'data-sizes="auto" ' +
      'alt="{{itemTitle}}">';
    itemImagesHtml += "</div>";
    itemImagesHtml += "</div>";

    var image_size =
      boostPFSThemeConfig.custom.max_height +
      "x" +
      boostPFSThemeConfig.custom.max_height;
    var max_width =
      images.length > 0
        ? boostPFSThemeConfig.custom.max_height * aspect_ratio
        : 0;
    itemImagesHtml +=
      '<noscript><img class="grid-view-item__image" src="' +
      Utils.getFeaturedImage(images, image_size + "@2x") +
      '" alt="{{itemTitle}}" style="max-width: ' +
      max_width +
      'px;"></noscript>';
    itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

    // Add Vendor
    var itemVendorHtml = boostPFSThemeConfig.custom.vendor_enable
      ? boostPFSTemplate.vendorGridHtml
      : "";
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Reviews
    if (
      typeof Integration === "undefined" ||
      !Integration.hascompileTemplate("reviews")
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, "");
    }

    // Set quantity symbol
    const quantitySymbol = data.tags.includes("pall") ? "pall (10 kvm)" : "kvm";

    const variantSumPositiveInventory = data.variants.reduce(function (a, b) {
      return a + Math.max(b.inventory_quantity, 0);
    }, 0);

    const nonNullVariantIncomingDates = data.variants.filter(
      (variant) => !!variant.next_incoming_date
    ); // Remove falsy
    const variantIncomingDates = nonNullVariantIncomingDates.map(function (
      variant
    ) {
      return new Date(variant.next_incoming_date);
    });

    // If incoming stock is delayed we don't want to display incoming dates in the past for customers
    const futureVariantIncomingDates = variantIncomingDates.filter(
      (date) => date >= Date.now()
    );

    let soonestIncomingDate = null;
    if (futureVariantIncomingDates.length > 0) {
      soonestIncomingDate = new Date(
        Math.min.apply(Math, futureVariantIncomingDates)
      );
    }

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(
      /{{variantSumInventory}}/g,
      variantSumPositiveInventory
    );
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data)
    );

    itemHtml = itemHtml.replace(/{{quantitySymbol}}/g, quantitySymbol);

    if (variantSumPositiveInventory < 1) {
      itemHtml = itemHtml.replace(
        /{{hideVariantSumInventoryClass}}/g,
        "visually-hidden"
      );
    } else {
      itemHtml = itemHtml.replace(/{{hideVariantSumInventoryClass}}/g, "");
    }

    if (soonestIncomingDate) {
      var soonestDateString = soonestIncomingDate.toLocaleDateString("sv-SE", {
        // you can use undefined as first argument
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      itemHtml = itemHtml.replace(
        /{{variantMinIncomingDate}}/g,
        soonestDateString
      );
      if (variantSumPositiveInventory > 0) {
        itemHtml = itemHtml.replace(
          /{{hideSoonestIncomingDateInventoryClass}}/g,
          "visually-hidden"
        );
      } else {
        itemHtml = itemHtml.replace(
          /{{hideSoonestIncomingDateInventoryClass}}/g,
          ""
        );
      }
    } else {
      itemHtml = itemHtml.replace(
        /{{hideSoonestIncomingDateInventoryClass}}/g,
        "visually-hidden"
      );
    }

    return itemHtml;
  };

  // Build Image style
  function buildImageStyle(data) {
    var images = data.images_info;
    var imgId = "ProductCardImage-" + data.id;
    var wrapperId = "ProductCardImageWrapper-" + data.id;
    var imageStyle = "";
    if (images.length > 0) {
      var image = images[0];
      var width = boostPFSThemeConfig.custom.max_height;
      var height = boostPFSThemeConfig.custom.max_height;
      var aspect_ratio = image.width / image.height;
      var small_style = true;
      var container_aspect_ratio = (width * 1.0) / height;

      if (image.aspect_ratio < 1.0) {
        var maximum_width = height * aspect_ratio;
        if (image.height <= height) {
          var maximum_height = image.height;
          maximum_width = image.width;
        } else {
          var maximum_height = height;
        }
      } else if (aspect_ratio < container_aspect_ratio) {
        var maximum_height = height / aspect_ratio;
        if (image.height <= height) {
          var maximum_height = image.height;
          var maximum_width = image.width;
        } else {
          var maximum_height = height;
          var maximum_width = height * aspect_ratio;
        }
      } else {
        var maximum_height = height / aspect_ratio;
        if (image.width <= width) {
          maximum_height = image.height;
          var maximum_width = image.width;
        } else {
          var maximum_width = width;
          maximum_height = maximum_width / aspect_ratio;
        }
      }

      imageStyle += "<style>";
      if (small_style) imageStyle += "@media screen and (min-width: 750px) {";
      imageStyle +=
        "#" +
        imgId +
        " {" +
        // 'max-width: ' + maximum_width + 'px;' +
        // 'max-height: ' + maximum_height + 'px;' +
        "}" +
        "#" +
        wrapperId +
        " {" +
        // 'max-width: ' + maximum_width + 'px;' +
        // 'max-height: ' + maximum_height + 'px;' +
        "}";
      if (small_style) imageStyle += "}";

      if (small_style) {
        if (aspect_ratio < 1) {
          maximum_width = 750 * aspect_ratio;
        } else {
          if (image.width < 750) {
            maximum_width = image.width;
          } else {
            maximum_width = 750;
          }
        }
        imageStyle += "@media screen and (max-width: 749px) {";
        imageStyle +=
          "#" +
          imgId +
          " {" +
          "max-width: " +
          maximum_width +
          "px;" +
          "max-height: 750px;" +
          "}" +
          "#" +
          wrapperId +
          " {" +
          "max-width: " +
          maximum_width +
          "px;" +
          "}";
        imageStyle += "}";
      }
      imageStyle += "</style>";
    }
    return imageStyle;
  }

  ProductListItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data["variants"][0];
    if (Utils.getParam("variant") !== null && Utils.getParam("variant") != "") {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam("variant");
      });
      if (typeof paramVariant[0] !== "undefined")
        firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data["variants"].length; i++) {
        if (data["variants"][i].available) {
          firstVariant = data["variants"][i];
          break;
        }
      }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = boostPFSTemplate.productListItemHtml;

    // Add onSale label
    var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : "";
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

    // Add soldOut label
    var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : "";
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

    // Add Thumbnail
    var itemThumbUrl =
      images.length > 0
        ? Utils.optimizeImage(images[0]["src"], "600x600")
        : boostPFSConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Vendor
    var itemSmallVendorHtml = boostPFSThemeConfig.custom.vendor_enable
      ? boostPFSTemplate.vendorSmallListHtml
      : "";
    itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
    var itemMediumVendorHtml = boostPFSThemeConfig.custom.vendor_enable
      ? boostPFSTemplate.vendorMediumListHtml
      : "";
    itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

    // Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Reviews
    if (
      typeof Integration === "undefined" ||
      !Integration.hascompileTemplate("reviews")
    ) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, "");
    }

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildProductItemUrl(data)
    );

    return itemHtml;
  };

  function buildPrice(data, onSale, priceVaries) {
    var priceHtml = "",
      onSaleClass = onSale ? " price--on-sale" : "";

    priceHtml += '<dl class="price' + onSaleClass + '" data-price>';
    // if (boostPFSThemeConfig.custom.vendor_enable) {
    //   priceHtml += '<div class="price__vendor">';
    //   priceHtml += "<dt>";
    //   priceHtml +=
    //     '<span class="visually-hidden">' +
    //     boostPFSThemeConfig.label.vendor +
    //     "</span>";
    //   priceHtml += "</dt>";
    //   priceHtml += "<dd>";
    //   priceHtml += data.vendor;
    //   priceHtml += "</dd>";
    //   priceHtml += "</div>";
    // }
    priceHtml += '<div class="price__sale">';
    priceHtml += "<dt>";
    priceHtml +=
      '<span class="visually-hidden visually-hidden--inline">' +
      boostPFSThemeConfig.label.sale_price +
      "</span>";
    priceHtml += "</dt>";
    priceHtml += "<dd>";
    priceHtml += '<span class="price-item price-item--sale" data-sale-price>';
    priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
    priceHtml += "</span> ";
    priceHtml +=
      '<span class="visually-hidden price-item__label" aria-hidden="true">' +
      boostPFSThemeConfig.label.sale +
      "</span>";
    priceHtml += "</dd>";
    priceHtml += "</div>";
    priceHtml += '<div class="price__regular">';
    priceHtml += "<dt>";
    priceHtml +=
      '<span class="visually-hidden visually-hidden--inline">' +
      boostPFSThemeConfig.label.regular_price +
      "</span>";
    priceHtml += "</dt>";
    priceHtml += "<dd>";
    priceHtml +=
      '<span class="price-item price-item--regular" data-regular-price>';
    if (data.available) {
      if (onSale) {
        priceHtml += Utils.formatMoney(
          data.compare_at_price_min,
          Globals.moneyFormat
        );
      } else {
        priceHtml += Utils.formatMoney(data.price_min, Globals.moneyFormat);
      }
    } else {
      priceHtml += boostPFSThemeConfig.label.sold_out;
    }
    priceHtml += "</span>";
    priceHtml += "</dd>";
    priceHtml += "</div>";
    priceHtml += "</dl>";

    return priceHtml;
  }

  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return "";
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;

    // Build Previous
    var previousHtml =
      currentPage > 1
        ? boostPFSTemplate.previousActiveHtml
        : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage - 1)
    );
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

    // Build Next
    var nextHtml =
      currentPage < totalPage
        ? boostPFSTemplate.nextActiveHtml
        : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(
      /{{itemUrl}}/g,
      Utils.buildToolbarLink("page", currentPage, currentPage + 1)
    );
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

    // Build page items
    var currentPage = boostPFSThemeConfig.label.current_page
      .replace(/{{ current }}/g, currentPage)
      .replace(/{{ total }}/g, totalPage);
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);

    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = "";
    if (boostPFSTemplate.hasOwnProperty("sortingHtml")) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = "";
        for (var k in sortingArr) {
          sortingItemsHtml +=
            '<option value="' + k + '">' + sortingArr[k] + "</option>";
        }
        html = boostPFSTemplate.sortingHtml.replace(
          /{{sortingItems}}/g,
          sortingItemsHtml
        );
      }
    }
    return html;
  };

  // Build Display type
  ProductDisplayType.prototype.compileTemplate = function () {
    var itemHtml = "<span>View As </span>";
    itemHtml +=
      '<a href="' +
      Utils.buildToolbarLink("display", "list", "grid") +
      '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
    itemHtml +=
      '<a href="' +
      Utils.buildToolbarLink("display", "grid", "list") +
      '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
    itemHtml = itemHtml.replace(
      /{{class.productDisplayType}}/g,
      Class.productDisplayType
    );

    return itemHtml;
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function () {
    var productSelector = jQ(Selector.products);
    if (Globals.queryParams.display == "list") {
      if (productSelector.children(".list-view-items").length == 0) {
        productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
      }
      productSelector.removeClass("grid grid--uniform grid--view-items");
    } else {
      if (productSelector.children(".list-view-items").length > 0) {
        productSelector.children(".list-view-items").children().unwrap();
      }
      productSelector.addClass("grid grid--uniform grid--view-items");
    }
  };

  // Build Additional Elements
  FilterResult.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    var totalProduct = "";
    if (data.total_product == 1) {
      totalProduct = boostPFSThemeConfig.label.items_with_count_one.replace(
        /{{ count }}/g,
        data.total_product
      );
    } else {
      totalProduct = boostPFSThemeConfig.label.items_with_count_other.replace(
        /{{ count }}/g,
        data.total_product
      );
    }
    jQ(".boost-pfs-filter-total-product").html(totalProduct);

    if (window.location.search.includes("pf_")) {
      jQ("#collection-template-clear-filter").removeAttr("disabled");
    } else {
      jQ("#collection-template-clear-filter").prop("disabled", true);
    }
  };
})();

function resetFilters(data) {
  var urlParam = window.location.search;

  jQ(".boost-pfs-filter-option-item").each(function () {
    jQ(this).removeClass("selected");
  });
  jQ(".boost-pfs-filter-button").each(function () {
    jQ(this).removeAttr("aria-checked");
  });

  jQ("#collection-template-clear-filter").addClass("hide-button");

  var urlNoParam = window.location.href.split(urlParam)[0];
  window.location.replace(urlNoParam);
}
